import request from 'utils/request'
import { LENGJ_HEADERS } from '@/config/lengj-index'

//查-登记信息信息
export const getCheckInfoList = data => {
  return request().post(
    'riskraider/v3.1/business/getEnterpriseBusinessInformation',
    data,
    {
      headers: LENGJ_HEADERS,
    },
  )
}
